// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query ParentCategories($filterBy: InputParentCategoriesQueryFilter)  {\nparentCategories(filterBy: $filterBy)  {\n__typename  \nid  \nformattedName  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.parentCategories;
  return {
    parentCategories: value$1.map(value => ({
      __typename: value.__typename,
      id: value.id,
      formattedName: value.formattedName
    }))
  };
}

function serialize(value) {
  let value$1 = value.parentCategories;
  let parentCategories = value$1.map(value => {
    let value$1 = value.formattedName;
    let value$2 = value.id;
    let value$3 = value.__typename;
    return {
      __typename: value$3,
      id: value$2,
      formattedName: value$1
    };
  });
  return {
    parentCategories: parentCategories
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputParentCategoriesQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    shopIds: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputParentCategoriesQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputParentCategoriesQueryFilter(archived, shopIds, param) {
  return {
    archived: archived,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputParentCategoriesQueryFilter: serializeInputObjectInputParentCategoriesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputParentCategoriesQueryFilter: makeInputObjectInputParentCategoriesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputParentCategoriesQueryFilter: serializeInputObjectInputParentCategoriesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputParentCategoriesQueryFilter: makeInputObjectInputParentCategoriesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function useCategoriesQueryFn(variables) {
  return AsyncResult.mapError(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables)), param => {});
}

function CatalogCategorySelectFilter(props) {
  let onChange = props.onChange;
  let __useCategoriesQuery = props.useCategoriesQuery;
  let value = props.value;
  let shopId = props.shopId;
  let useCategoriesQuery = __useCategoriesQuery !== undefined ? __useCategoriesQuery : useCategoriesQueryFn;
  let queryResult = useCategoriesQuery({
    filterBy: {
      archived: "EXCLUDED",
      shopIds: shopId !== undefined ? ({
          _in: [shopId]
        }) : undefined
    }
  });
  let categories;
  if (typeof queryResult !== "object") {
    categories = queryResult === "NotAsked" ? [] : [];
  } else if (queryResult.TAG === "Reloading") {
    let match = queryResult._0;
    categories = match.TAG === "Ok" ? match._0.parentCategories : [];
  } else {
    let match$1 = queryResult._0;
    categories = match$1.TAG === "Ok" ? match$1._0.parentCategories : [];
  }
  let items = categories.map(category => ({
    TAG: "Option",
    key: category.id,
    label: category.formattedName,
    value: {
      id: category.id,
      name: category.formattedName
    }
  }));
  let defaultItem_1 = I18n.template(I18n.t("All{{feminine}}"), undefined, undefined);
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "__all__",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let unclassifiedItem_1 = I18n.template(I18n.t("Not classified"), undefined, undefined);
  let unclassifiedItem_2 = {
    id: null,
    name: I18n.t("Not classified")
  };
  let unclassifiedItem_4 = true;
  let unclassifiedItem = {
    TAG: "Option",
    key: "__not-classified__",
    label: unclassifiedItem_1,
    value: unclassifiedItem_2,
    exclusive: unclassifiedItem_4
  };
  let sections = [
    {
      items: [
        defaultItem,
        unclassifiedItem
      ]
    },
    {
      items: items,
      title: I18n.t("Categories")
    }
  ];
  let onSelectionChange = selection => {
    if (selection.TAG === "Single") {
      return onChange(selection._0);
    }
  };
  let disabled = Stdlib_Option.isNone(shopId);
  let loading = AsyncResult.isBusy(queryResult);
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Select.make, {
      label: I18n.t("Category"),
      placeholder: I18n.t("Select a category"),
      preset: "filter",
      size: "compact",
      highlighted: Stdlib_Option.isSome(value),
      disabled: disabled,
      loading: loading,
      sections: sections,
      value: {
        TAG: "Single",
        _0: value
      },
      onChange: onSelectionChange
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Please select a shop beforehand.")
    }),
    disabled: !disabled,
    delay: 350
  });
}

let make = CatalogCategorySelectFilter;

export {
  Query,
  useCategoriesQueryFn,
  make,
}
/* query Not a pure module */
